<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="odrea">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-2 xtl"><span class="nav-back wt"  @click="$router.go(-1)"></span></div>
                            <div class="col-8 tfw-5 tf-18">Daily Income</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-3" id="dtaod" style="display: none;">
                                <div class="row mr-0 mb-2 pt-3 pb-3 tf-16 tfw-5 myma">
                                    <div class="col-6 xtl">2023-02-06</div>
                                    <div class="col-6 xtr">+150.96</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="footer">
                    <div class="col-12 nav-bar" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem" id="moxht2b4u" onclick="home()">
                                    <div class="xtc"><span class="icon home" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="raeiyf2m0" onclick="group()">
                                    <div class="xtc"><span class="icon group" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="sfrm6bvy" onclick="wallet()">
                                    <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="mcpnvd2my" onclick="my()">
                                    <div class="xtc"><span class="icon my" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>